// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorScreen_root__c5hbN","title":"ErrorScreen_title__srxdw","message":"ErrorScreen_message__Lnh1o","button":"ErrorScreen_button__4MEvR"};